export default "__VITE_ASSET__Cc5QF8Gj__"